import { CUSTOMER_TYPE, RECIPIENT_TYPES } from 'components/common/constants';
import { trimTextContent } from 'services/utils';

export default (templateData) => {
  const baseModel = {
    type: CUSTOMER_TYPE[templateData?.recipientType?.toUpperCase()]?.toUpperCase(),
    internalWalletNumber: templateData?.internalWalletNumber
  };

  if (templateData?.recipientType === RECIPIENT_TYPES.INDIVIDUAL) {
    return {
      ...baseModel,
      firstName: trimTextContent(templateData?.firstName),
      lastName: trimTextContent(templateData?.lastName)
    };
  }

  if (templateData?.recipientType === RECIPIENT_TYPES.COMPANY) {
    return {
      ...baseModel,
      companyName: trimTextContent(templateData?.companyName)
    };
  }

  return baseModel;
};
